<template>
	<div grey-back full-height>

		<v-toolbar dark flat fixed nopadding>
      		<v-toolbar-side-icon @click="fn_goBack"><v-icon>arrow_back</v-icon></v-toolbar-side-icon>
      		<v-toolbar-title>My Accountant</v-toolbar-title>
      		<v-spacer></v-spacer>
      		<v-btn icon to="/settings/accountant/items/new" v-if="items.length < 1 && !listHasError"><v-icon>add</v-icon></v-btn>
            <!-- <v-btn icon to="/settings/accountant/items/new"><v-icon>add</v-icon></v-btn> -->
    	</v-toolbar>

	    <div class="hasToolbar">
	    	
	    	<v-list two-line nopadding>
	    		
	    		<div v-for="(item, index) in items" :key="index">
	    			<v-list-tile>

	    				<v-list-tile-action>
	    					<a :href="'tel:'+item.PhoneNumber" style="text-decoration:none">
			    				<v-icon color="primary">call</v-icon>
			    			</a>
	                    	<!-- <v-btn icon color="red"><v-icon>delete</v-icon></v-btn> -->
			            </v-list-tile-action>

	                    <v-list-tile-content>
	                        <v-list-tile-title>{{item.Name ? item.Name : 'Accountant ' + (index+1)}}</v-list-tile-title>
	                        <v-list-tile-sub-title>{{item.PhoneNumber}}</v-list-tile-sub-title>
	                    </v-list-tile-content>

	                    <v-list-tile-action v-if="!$root.CurrentBusiness.IsAccountantOnly">
	                    	<v-btn icon @click="fn_openDialogConfirmation(item, index)"><v-icon color="red">delete</v-icon></v-btn>
			            </v-list-tile-action>

	                </v-list-tile>

	                <v-divider v-if="items.length-1!=index"></v-divider>

	    		</div>

	    	</v-list>

	    	<div v-if="!items.length" class="display_msg">There are no accountant added yet!</div>
	    </div>

	    <dialog-confirmation ref="ref_dialogConfirmation" header="Remove Accountant?" :actionMethod="fn_getToken" :params="{type:'delete'}" :displayView='true'></dialog-confirmation>

	</div>
</template>

<script>

import dialogConfirmation from '../../dialogs/dialog_confirmation'

	export default{
		data(){
			return{
				items:[],
				seletedItem:null,
                listHasError:false
			}
		},
		components:{
			'dialog-confirmation': dialogConfirmation
		},
		methods:{
			fn_goBack: function(){
				this.$router.go(-1);
			},

			fn_openDialogConfirmation: function(item, index){
				this.seletedItem = item;
				this.seletedItem.itemIndex = index;
				this.$refs['ref_dialogConfirmation'].openDialogWeb();
			},

			fn_getToken: function(type){
				self = this;
				this.showLoading("Please wait...");
				this.$root.fn_getAuthToken(function(token){
                    type == "items" ? self.fn_items(token) : self.fn_removeAccountant(token)
                });
			},

			fn_items: function(token){
				if(!navigator.onLine){
	                this.showToast('Internet not available');
	                return;
	            }
	            
	            let self = this;
	            let dataObj = {};
	            dataObj.businessId = this.$root.CurrentBusiness.BusinessID;
	            dataObj.token = token;
	            this.getServerData('GetAccountantList', dataObj, 
	                {
	                    onSuccess: function(response){
	                    	console.log(response);
	                    	self.items = JSON.parse(response);
                            self.listHasError = false;
	                        self.hideLoading();
	                    }, 
	                    onError: function(error){
	                        console.log(error);
                            self.listHasError = true;
	                        self.hideLoading();
	                        if(typeof JSON.parse(error) == 'object'){
	                            let response = JSON.parse(error);
	                            self.showToast(response.Message);
	                        }
	                    }, 
	                }
	            );
			},

			fn_removeAccountant: function(token){
				this.$refs['ref_dialogConfirmation'].closeDialogWeb();

				if(!navigator.onLine){
	                this.showToast('Internet not available');
	                return;
	            }
	            
	            let self = this;
	            let dataObj = {};
	            dataObj.businessId = this.$root.CurrentBusiness.BusinessID;
	            dataObj.userId = this.seletedItem.UserID;
	            dataObj.token = token;
	            this.getServerData('RemoveAccountant', dataObj, 
	                {
	                    onSuccess: function(response){
	                    	// self.items = JSON.parse(response.data);
	                    	self.items.splice(self.seletedItem.itemIndex, 1);
	                        self.hideLoading();
	                        self.showToast('Accountant deleted!');
	                    }, 
	                    onError: function(error){
	                        console.log(error);
	                        self.hideLoading();
	                        if(typeof JSON.parse(error) == 'object'){
	                            let response = JSON.parse(error);
	                            self.showToast(response.Message);
	                        }
	                    }, 
	                }
	            );
			},

			
		},

	  	mounted: function(){
	  		window.js_globals.fn_onBackPress = this.fn_goBack;
	  		this.fn_getToken('items');
	  		// this.fn_getTempBusinesses();
	  	},

	  	beforeRouteLeave (to, from, next) {
			if(this.$refs['ref_dialogConfirmation'].dialog_confimation){
				this.$refs['ref_dialogConfirmation'].dialog_confimation = false;
				next(false);
			}
			else{
				next(true);	
			}
	    }
	}
</script>


// WEBPACK FOOTER //
// src/components/settings/accountant/items.vue